import { Auth } from "domain/model/Auth"
import pn from "core/utils/pn"
import { postAPI, Server } from "core/utils/axios"
import { API_ADMIN, API_CREATE_GOAL_SETTING_SESSION, API_V4_ADMIN } from "core/constants/strings"
import GoalSettingDataSource from "data/dataSource/Admin/GoalSettingDataSourse"
import { GoalSettingSession } from "domain/model/GoalSettingSession"
import GoalSettingMentorDataSource from "data/dataSource/Admin/GoalSettingMentorDataSource"
import { GetGoalSettingMentorStudentsDetails, UpdateGoalSettingMentorDetails } from "domain/model/GoalSettingMentor"

const server = new Server()
export default class GoalSettingMentorDataSourceImpl implements GoalSettingMentorDataSource {
  async updateGoalSettingMentor(auth: Auth, details: UpdateGoalSettingMentorDetails): Promise<any> {
    try {
      const response = await server.post(
        pn(API_ADMIN, "goal_setting", "update_goal_setting_mentor"),

        {
          old_goal_setting_mentor_id: details.old_goal_setting_mentor_id,
          new_goal_setting_mentors: details.selectedMentors,
        },
        {
          Authorization: `Bearer ${auth.id_token}`,
        }
      )
      return response
    } catch (error) {
      return error
    }
  }

  async getGoalSettingMentorStudents(auth: Auth, details: GetGoalSettingMentorStudentsDetails): Promise<any> {
    try {
      console.log("hello i am here in the api")
      const response = await server.post(
        pn(API_ADMIN, "goal_setting", "get_goal_setting_mentor_students"),

        {
          mentor_id: details.mentor_id,
        },
        {
          Authorization: `Bearer ${auth.id_token}`,
        }
      )
      return response
    } catch (error) {
      return error
    }
  }
}
